import { render, staticRenderFns } from "./PmAkademi.vue?vue&type=template&id=7d0a9e76&"
import script from "./PmAkademi.vue?vue&type=script&lang=js&"
export * from "./PmAkademi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports